import { render, staticRenderFns } from "./PhysicalVotesTable.vue?vue&type=template&id=7db272ec&"
import script from "./PhysicalVotesTable.vue?vue&type=script&lang=js&"
export * from "./PhysicalVotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports